import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Container,
  Grid,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { generateAndSendPDF } from "../utils/generateAndSendPDF";

const AltaUsuarios = () => {
  const [isOpen, setIsOpen] = useState(true);
  const today = new Date().toISOString().split("T")[0];
  const oneMonthLater = new Date();
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
  const defaultFechaBaja = oneMonthLater.toISOString().split("T")[0];
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 1);
  const maxDateFormatted = maxDate.toISOString().split("T")[0];

  const getInitialFormData = () => ({
    apellidos: "",
    nombre: "",
    departamento: "",
    fechaAlta: "",
    fechaBaja: "",
    email: "",
    telefono: "",
    ordenador: false,
    pantallas: false,
    numPantallas: "",
    movil: false,
    otroHardware: "",
    accesoServidor: false,
    office: false,
    abbantia: false,
    accesoRemoto: false,
    appInterna: false, // Se usa una sola convención
    observaciones: "",
    usuarioAbbantia: false,
    pinPortero: false,
    firmadoPor: "",
    fechaFirma: today,
    tieneFechaBaja: false,
  });

  const [formData, setFormData] = useState(getInitialFormData());

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;
    const currentData = { ...formData };

    if (currentData.pantallas && !["1", "2"].includes(currentData.numPantallas)) {
      toast.error("El número de pantallas debe ser 1 o 2.");
      return;
    }

    try {
      // Normalizar datos para evitar valores vacíos en columnas numéricas/fecha
      const payload = {
        ...currentData,
        numPantallas: currentData.pantallas
          ? currentData.numPantallas
            ? parseInt(currentData.numPantallas, 10)
            : null
          : null,
        fechaBaja:
          currentData.tieneFechaBaja && currentData.fechaBaja ? currentData.fechaBaja : null,
      };

      const response = await fetch("guardar_usuario.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.success) {
        toast.success(result.message);

        // Enviar todos los datos del formulario para generar y enviar el PDF
        const pdfResponse = await generateAndSendPDF(
          currentData,
          "Alta de Usuario"
        );
        toast.success(pdfResponse);

        const resetData = getInitialFormData();
        setFormData(resetData);
        if (formElement && typeof formElement.reset === "function") {
          formElement.reset();
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Error al conectar con el servidor.");
    }
  };

  const capitalizeWords = (str) => {
    return str
      .split(/(?=[A-Z])/)
      .join(" ")
      .replace(/^\w/, (c) => c.toUpperCase());
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <Nav isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />
      <Container
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            p: 4,
            borderRadius: 2,
            boxShadow: 2,
            width: "100%",
            maxWidth: "800px",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            textAlign="center"
            style={{ marginBottom: "35px" }}
          >
            Alta de Usuarios
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Apellidos"
                  name="apellidos"
                  required
                  onChange={handleChange}
                  helperText="Los 2 apellidos del usuario"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nombre"
                  name="nombre"
                  required
                  onChange={handleChange}
                  helperText="Nombre del usuario"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Departamento"
                  name="departamento"
                  required
                  onChange={handleChange}
                  helperText="Departamento del usuario"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Correo"
                  name="email"
                  onChange={handleChange}
                  type="email"
                  helperText="Correo corporativo a utilizar por el usuario (se creará si no existe)"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Fecha alta"
                  name="fechaAlta"
                  value={formData.fechaAlta}
                  onChange={handleChange}
                  InputProps={{
                    inputProps: { min: today, max: maxDateFormatted },
                  }}
                  InputLabelProps={{ shrink: true }}
                  helperText="Seleccione la fecha de alta"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Teléfono"
                  name="telefono"
                  onChange={handleChange}
                  inputProps={{ maxLength: 9, pattern: "[0-9]{9}" }}
                  helperText="Teléfono corporativo (si disponible)"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="tieneFechaBaja"
                      checked={formData.tieneFechaBaja}
                      onChange={handleChange}
                    />
                  }
                  label="¿Fecha de baja?"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                {formData.tieneFechaBaja && (
                  <TextField
                    fullWidth
                    type="date"
                    label="Fecha baja"
                    name="fechaBaja"
                    value={formData.fechaBaja || ""}
                    onChange={handleChange}
                    InputProps={{
                      inputProps: { min: today, max: maxDateFormatted },
                    }}
                    helperText="Seleccione la fecha de baja"
                  />
                )}
              </Grid>

              {/* Campo Ordenador */}
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="ordenador"
                      checked={formData.ordenador}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setFormData((prev) => ({
                          ...prev,
                          ordenador: checked,
                          pantallas: checked ? true : prev.pantallas, // Si se selecciona ordenador, pantallas se marca
                        }));
                      }}
                    />
                  }
                  label="Ordenador"
                />
              </Grid>

              {/* Campo Pantallas (deshabilitado si ordenador está activo) */}
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="pantallas"
                      checked={formData.pantallas}
                      onChange={handleChange}
                      disabled={formData.ordenador} // Deshabilita el checkbox si ordenador está seleccionado
                    />
                  }
                  label="Pantallas"
                />
                {formData.pantallas && (
                  <TextField
                    fullWidth
                    label="Número de pantallas"
                    name="numPantallas"
                    helperText="1 o 2 pantallas"
                    onChange={handleChange}
                    value={formData.numPantallas}
                    inputProps={{ pattern: "1|2", maxLength: 1 }}
                    required
                  />
                )}
              </Grid>

              {/* Otros campos */}
              {["movil", "accesoServidor", "office", "abbantia", "accesoRemoto", "appInterna"].map(
                (item) => (
                  <Grid item xs={12} sm={4} key={item}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={item}
                          checked={formData[item]}
                          onChange={handleChange}
                        />
                      }
                      label={capitalizeWords(item)}
                    />
                  </Grid>
                )
              )}

              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="usuarioAbbantia"
                      checked={formData.usuarioAbbantia}
                      onChange={handleChange}
                    />
                  }
                  label="Usuario Abbantia"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="pinPortero"
                      checked={formData.pinPortero}
                      onChange={handleChange}
                    />
                  }
                  label="Pin entrada"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Otro hardware"
                  name="otroHardware"
                  onChange={handleChange}
                  helperText="Cualquier otro hardware necesario"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  name="observaciones"
                  multiline
                  rows={3}
                  onChange={handleChange}
                  helperText="Cualquier observación adicional"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Firmado por"
                  name="firmadoPor"
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Fecha firma"
                  name="fechaFirma"
                  value={today}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
              fullWidth
            >
              Registrar usuario
            </Button>
          </form>
        </Box>
      </Container>
      <Footer />
      {/* Aquí agregamos el ToastContainer */}
      <ToastContainer />
    </Box>
  );
};

export default AltaUsuarios;
